module.exports = __webpack_public_path__ + "static/media/real-talk.3fe99c33.svg";